import { cn } from '@/lib/utils'

export const LoadingDots = ({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img
    src='/public/img/loading-three-dots.gif'
    className={cn('mb-1 w-5 select-none', className)}
    alt='Loading'
    {...props}
  />
)
